import { render, staticRenderFns } from "./hotArea.module.vue?vue&type=template&id=06b587bd&scoped=true"
import script from "./hotArea.module.vue?vue&type=script&lang=js"
export * from "./hotArea.module.vue?vue&type=script&lang=js"
import style0 from "./hotArea.module.vue?vue&type=style&index=0&id=06b587bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b587bd",
  null
  
)

export default component.exports